import React from 'react';
import { List, TextField, SearchInput, NumberField } from 'react-admin';

import Datagrid from '../common/Datagrid';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import ResourceLinkField from '../common/fields/ResourceLinkField';

const customerFilters = [
    <SearchInput source="q" alwaysOn />
];

const CustomerList = props => (
    <List filters={customerFilters} {...props}>
        <Datagrid>
            <ResourceLinkField label="Id" resource="customers" sortBy="id">
                <TextField source="id" />
            </ResourceLinkField>
            <ResourceLinkField label="Name" resource="customers" sortBy="name">
                <TextField source="name" />
            </ResourceLinkField>
            <NumberField source="current_total_timesheet_hours" label="Timesheet (h)" />
            <NumberField source="current_total_budget_hours" label="Budget (h)" />
            <NumberField source="current_budget_utilization_rate" label="Utilization %" options={{ style: 'percent', minimumFractionDigits: 2 }} />
            <RecordSplitButton />
        </Datagrid>
    </List>
);

export default CustomerList;